const RELOADED_CHUNK_KEY = 'aradcore:reloaded-chunk'

export function shouldReloadForFailedChunk(
  error: unknown,
  storage: Pick<Storage, 'getItem' | 'setItem'>,
): boolean {
  const failedChunk = error instanceof Error ? error.message : String(error ?? '')
  if (!failedChunk || storage.getItem(RELOADED_CHUNK_KEY) === failedChunk) return false
  storage.setItem(RELOADED_CHUNK_KEY, failedChunk)
  return true
}
